import type { IConfig } from '@ohpen/react-utils';
import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

export function getOidcConfig(config: IConfig): AuthProviderProps {
  const customScopes = config.AWS?.APP_CLIENT_CUSTOM_SCOPES || [];
  const baseScopes = 'openid profile email';
  const scope = customScopes.length > 0 ? `${baseScopes} ${customScopes.join(' ')}` : baseScopes;

  return {
    authority: `https://cognito-idp.${config.AWS.REGION}.amazonaws.com/${config.AWS.USER_POOL_ID}`,
    client_id: config.AWS.USER_POOL_APP_CLIENT_ID,
    redirect_uri: config.AWS.USER_POOL_REDIRECT_URL,
    post_logout_redirect_uri: config.AWS.USER_POOL_REDIRECT_URL,
    scope,
    automaticSilentRenew: true,
    // localStorage keeps the session across tabs and direct URL navigation; the default sessionStorage
    // is tab-scoped, so a link opened in a new tab would force a new sign-in.
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback: user => {
      // Restores the destination encoded in the OIDC state, and strips the OIDC query params from the URL.
      const from = (user?.state as { from?: string } | undefined)?.from;
      globalThis.history.replaceState({}, document.title, from ?? globalThis.location.pathname);
    },
  };
}
